
  /* ═══ CAJON DE CELU ═══
     Abre con la hamburguesa y ahora es un panel a pantalla completa que entra
     desde la izquierda, no un acordeon. Con acordeon el contenido empujaba la
     pagina y no habia donde meter el subpanel.
     Mientras esta abierto se bloquea el scroll del fondo: si no, al deslizar
     adentro del cajon se movia la pagina de atras. */
  (function(){
    var hdr=document.querySelector('.rz-hdr');
    var b=document.querySelector('[data-rz-burger]');
    var panel=document.getElementById('rz-hdr-panel');
    if(!hdr||!b||!panel) return;
    var scrollY=0;

    function abrir(){
      scrollY=window.scrollY;
      hdr.classList.add('is-open');
      document.body.style.position='fixed';
      document.body.style.top=(-scrollY)+'px';
      document.body.style.width='100%';
      b.setAttribute('aria-expanded','true');
    }
    function cerrar(){
      hdr.classList.remove('is-open');
      panel.classList.remove('is-sub');
      document.body.style.position='';
      document.body.style.top='';
      document.body.style.width='';
      window.scrollTo(0,scrollY);
      b.setAttribute('aria-expanded','false');
    }
    b.setAttribute('aria-expanded','false');
    b.setAttribute('aria-controls','rz-hdr-panel');
    b.addEventListener('click',function(e){
      e.preventDefault();
      if(hdr.classList.contains('is-open')) cerrar(); else abrir();
    });
    var cierres=document.querySelectorAll('[data-rz-cerrar]');
    for(var i=0;i<cierres.length;i++) cierres[i].addEventListener('click',cerrar);
    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape'||!hdr.classList.contains('is-open')) return;
      if(panel.classList.contains('is-sub')) panel.classList.remove('is-sub'); else cerrar();
    });

    /* Pastillas: cambian la grilla de tarjetas, igual que las filas del mega. */
    var pills=panel.querySelectorAll('.rz-hdr__pill');
    var grids=panel.querySelectorAll('.rz-hdr__pgrid');
    for(var k=0;k<pills.length;k++){(function(p,idx){
      p.addEventListener('click',function(){
        for(var q=0;q<pills.length;q++) pills[q].setAttribute('aria-selected', q===idx?'true':'false');
        for(var g=0;g<grids.length;g++) grids[g].classList.toggle('is-on', g===idx);
        panel.querySelector('.rz-hdr__pnl-scroll').scrollTop=0;
      });
    })(pills[k],k);}

    /* Subpanel: entra desde la derecha y se vuelve con la flecha. */
    var abre=panel.querySelectorAll('[data-sub]');
    for(var m=0;m<abre.length;m++){
      abre[m].addEventListener('click',function(){ panel.classList.add('is-sub'); });
    }
    var vuelve=panel.querySelectorAll('[data-rz-volver]');
    for(var v=0;v<vuelve.length;v++){
      vuelve[v].addEventListener('click',function(){ panel.classList.remove('is-sub'); });
    }
  })();

  /* ═══ MEGA: ABRIR, CERRAR Y CAMBIAR DE FILA ═══
     Todo pasa por UNA sola cosa animada: el alto del panel. Es lo que se ve en
     los videos de Huel:
       - al abrir, el panel BAJA — crece de alto desde cero, no aparece con un
         fade. En Huel eso dura 240ms; Mark lo pidio mas lento y quedo en 420,
         que es lo que se siente fluido en un panel de este tamaño;
       - al pasar de una fila a otra, el contenido cambia de golpe, en el mismo
         frame, y lo unico que se interpola es el alto;
       - al cerrar, vuelve a cero por el mismo camino.
     El alto tiene que ir en px: con "auto" el browser no interpola y el salto
     queda seco. Por eso lo mide el JS sobre el contenido, que conserva su alto
     real aunque el panel este colapsado.
     Ademas hay una demora chica antes de cambiar de fila: sin eso, al ir en
     diagonal desde la primera fila hasta una tarjeta de la derecha el mouse
     roza las otras filas y el panel parpadea. */
  (function(){
    var hdr=document.querySelector('.rz-hdr');
    var drops=document.querySelectorAll('.rz-hdr__drop');
    if(!hdr||!drops.length) return;

    function hayAlguno(){ return !!document.querySelector('.rz-hdr__drop.is-abierto'); }

    for(var m=0;m<drops.length;m++){(function(drop){
      var mega=drop.querySelector('.rz-hdr__mega');
      if(!mega) return;
      var dentro=mega.firstElementChild;
      var panes=mega.querySelector('[data-rz-panes]');
      var tabs=mega.querySelectorAll('.rz-hdr__tab');
      var lista=mega.querySelectorAll('.rz-hdr__pane');
      var activo=0, demora=null, abierto=false;

      function alto(){ return dentro?dentro.offsetHeight:0; }
      function ajustar(){ if(abierto) mega.style.height=alto()+'px'; }
      /* Abrir y cerrar van mas lentos que pasar de una fila a otra: el panel
         recorre todo su alto de una y ahi la lentitud se lee como fluidez,
         mientras que entre filas el salto es chico y 420ms se hace pesado.
         Los dos valores son "alto, visibility" en ese orden. */
      function ritmo(ms){ mega.style.transitionDuration=ms+'ms, 0s'; }

      function abrir(){
        abierto=true; ritmo(420);
        drop.classList.add('is-abierto');
        hdr.classList.add('is-mega');
        mega.style.height=alto()+'px';
      }
      function cerrar(){
        abierto=false; ritmo(420);
        drop.classList.remove('is-abierto');
        mega.style.height='0px';
        clearTimeout(demora);
        if(!hayAlguno()) hdr.classList.remove('is-mega');
        // Vuelve a la primera fila, como cuando lo abris por primera vez.
        setTimeout(function(){ if(!abierto) poner(0,true); },260);
      }

      function poner(i,mudo){
        if(i===activo&&!mudo) return;
        ritmo(300);
        activo=i;
        for(var k=0;k<lista.length;k++){
          var on=(k===i);
          lista[k].classList.toggle('is-on',on);
          if(tabs[k]) tabs[k].setAttribute('aria-selected',on?'true':'false');
        }
        ajustar();
      }

      for(var i=0;i<tabs.length;i++){(function(t,idx){
        t.addEventListener('mouseenter',function(){
          clearTimeout(demora);
          demora=setTimeout(function(){ poner(idx); },70);
        });
        t.addEventListener('mouseleave',function(){ clearTimeout(demora); });
        t.addEventListener('focus',function(){ clearTimeout(demora); poner(idx); });
        t.addEventListener('click',function(e){ e.preventDefault(); clearTimeout(demora); poner(idx); });
      })(tabs[i],i);}

      drop.addEventListener('mouseenter',abrir);
      drop.addEventListener('mouseleave',cerrar);
      drop.addEventListener('focusin',abrir);
      drop.addEventListener('focusout',function(e){
        if(!drop.contains(e.relatedTarget)) cerrar();
      });
      document.addEventListener('keydown',function(e){
        if(e.key==='Escape'&&abierto){ cerrar(); var l=drop.querySelector('.rz-hdr__link'); if(l) l.blur(); }
      });

      // El alto depende de fotos que todavia pueden no haber cargado.
      window.addEventListener('load',ajustar);
      window.addEventListener('resize',ajustar);
      var imgs=mega.querySelectorAll('img');
      for(var q=0;q<imgs.length;q++){
        if(!imgs[q].complete) imgs[q].addEventListener('load',ajustar);
      }
      if('ResizeObserver' in window && panes){
        new ResizeObserver(ajustar).observe(panes);
      }
    })(drops[m]);}
  })();

  /* Pausa de la barra de anuncios. Antes frenaba sola al pasar el mouse por
     encima, pero la barra ocupa todo el ancho: se frenaba cada vez que el
     mouse subia al header sin querer. Ahora se frena solo si la frenan. */
  (function(){
    var barra=document.querySelector('[data-rz-promo]');
    var b=barra&&barra.querySelector('[data-rz-pausa]');
    if(!barra||!b) return;
    function poner(q){
      barra.classList.toggle('is-quieta',q);
      b.setAttribute('aria-label',q?'Reanudar los anuncios':'Pausar los anuncios');
      b.setAttribute('aria-pressed',q?'true':'false');
    }
    poner(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    b.addEventListener('click',function(e){
      e.preventDefault();
      poner(!barra.classList.contains('is-quieta'));
    });
  })();

  /* La barra tiene que ser infinita en CUALQUIER ancho.
     El truco de la cinta es: N copias del set y un desplazamiento de -50%, o
     sea N/2 copias. Para que no se vea el hueco, esas N/2 copias tienen que
     tapar la pantalla entera. Con un numero fijo de copias siempre hay un
     monitor donde no alcanza — a 2200px con 4 copias ya fallaba. Asi que las
     copias se cuentan aca, y la duracion se recalcula para que la velocidad
     (31 px por segundo) no cambie segun el ancho de la pantalla. */
  (function(){
    var cinta=document.querySelector('.rz-hdr__promo .rz-hdr__mq');
    if(!cinta) return;
    var VEL=31, base=cinta.querySelector('.rz-hdr__set');
    if(!base) return;
    var timer=null;
    function armar(){
      var anchoSet=base.getBoundingClientRect().width;
      if(!anchoSet) return;
      var mitad=Math.max(2,Math.ceil(window.innerWidth/anchoSet)+1);
      var faltan=mitad*2-cinta.children.length;
      for(var i=0;i<faltan;i++) cinta.appendChild(base.cloneNode(true));
      while(faltan<0){ cinta.removeChild(cinta.lastElementChild); faltan++; }
      cinta.style.animationDuration=(mitad*anchoSet/VEL).toFixed(2)+'s';
    }
    armar();
    window.addEventListener('load',armar);
    window.addEventListener('resize',function(){
      clearTimeout(timer); timer=setTimeout(armar,180);
    });
  })();

  /* Loop de la flecha en las tarjetas del mega. Es el mismo de las pastillas y
     de las cards, con el mismo detalle importante: el handler de animationend
     solo cierra el loop con la animacion de ENTRADA. Si cerrara con la primera
     que termina, cortaria a la flecha que entra a mitad de camino, porque la
     que sale dura 90ms y la que entra 240. */
  (function(){
    var cards=document.querySelectorAll('.rz-hdr__c');
    for(var i=0;i<cards.length;i++){(function(c){
      function play(cls){
        c.classList.remove('is-loop','is-loop-rev');
        void c.offsetWidth;
        c.classList.add(cls);
      }
      c.addEventListener('mouseenter',function(){ play('is-loop'); });
      c.addEventListener('mouseleave',function(){ play('is-loop-rev'); });
      c.addEventListener('animationend',function(e){
        if(e.animationName==='rz-hc-in'||e.animationName==='rz-hc-in-rev'){
          c.classList.remove('is-loop','is-loop-rev');
        }
      });
    })(cards[i]);}
  })();
